import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X, LogOut, Sparkles } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/"); };
  const links = [
    { to: "/browse", label: "Find a caregiver", key: "browse" },
    { to: "/how-it-works", label: "How it works", key: "how" },
    { to: "/pricing", label: "Pricing", key: "pricing" },
  ];

  return (
    <header data-testid="site-nav" className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAF7F2]/90 border-b border-taupe/60">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-full bg-forest text-linen flex items-center justify-center font-serif text-lg">S</span>
          <span className="font-serif text-xl tracking-tight text-forest">Sakeenah Circle</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-forest/80">
          {links.map((l) => (
            <Link key={l.key} to={l.to} className="hover:text-forest transition-colors" data-testid={`nav-${l.key}`}>{l.label}</Link>
          ))}
          {user && <Link to="/dashboard" className="hover:text-forest transition-colors" data-testid="nav-dashboard">Dashboard</Link>}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              {user.is_premium && <span className="badge-gold" data-testid="premium-badge"><Sparkles className="w-3 h-3" /> Premium</span>}
              <span className="text-sm text-forest/70">Hi, {user.name.split(" ")[0]}</span>
              <button onClick={doLogout} className="btn-outline flex items-center gap-1.5 text-sm" data-testid="nav-logout">
                <LogOut className="w-4 h-4" /> Sign out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-outline text-sm" data-testid="nav-login">Sign in</Link>
              <Link to="/register" className="btn-primary text-sm" data-testid="nav-register">Get started</Link>
            </>
          )}
        </div>
        <button className="md:hidden p-2 text-forest" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#FAF7F2] border-t border-taupe/60 px-5 py-4 space-y-3">
          {links.map((l) => (
            <Link key={l.key} to={l.to} onClick={() => setOpen(false)} className="block text-forest">{l.label}</Link>
          ))}
          {user && <Link to="/dashboard" onClick={() => setOpen(false)} className="block text-forest">Dashboard</Link>}
          <div className="pt-2 flex gap-2">
            {user ? (
              <button onClick={() => { setOpen(false); doLogout(); }} className="btn-outline text-sm w-full">Sign out</button>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="btn-outline text-sm w-1/2 text-center">Sign in</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="btn-primary text-sm w-1/2 text-center">Get started</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
